export const TABLET = "(min-width: 440px) and (max-width: 600px)";
export const MOBILE = "(max-width: 439px)";
export const DESKTOP = "(min-width: 601px)";
export const SMALL_HEIGHT_FOR_TABLET_AND_DESKTOP = "(max-height: 750px) and (min-width: 440px)";
export const HIGH_CONSTRANST_MODE_ENABLED = "((forced-colors: active) or (-ms-high-contrast: active)) and (prefers-color-scheme: dark)";
export const SMALL_HEIGHT = "(max-height: 300px)";
